'use strict';

ngApplyFocusDirective.$inject = [
  '$timeout',
];

export function ngApplyFocusDirective($timeout) {
  return function (scope, element, attrs) {
    scope.$watch(() => scope.$eval(attrs.ngApplyFocus), updateFocus);

    function updateFocus(newValue) {
      if (newValue === true) {
        $timeout(() => {
          element[0].focus();
        }, 1);
      }
    }
  };
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/misc-utils/ngApplyFocus.js